var PNHeaderV2,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

require('../../../../../core/frontend/groupon_modules/ariaKeyNavigation');

require('../../../../../modules/gig_body/header/frontend/views/pn_primarynav');

module.exports = PNHeaderV2 = (function(superClass) {
  extend(PNHeaderV2, superClass);

  function PNHeaderV2($el) {
    this.$el = $el;
    this.$primaryNav = this.$el.find('.primary-nav');
    this.initialize();
  }

  PNHeaderV2.prototype.initialize = function() {
    if (!$('#ls-lite-header').length) {
      return new Groupon.LS.Header.PNPrimaryNav(this.$primaryNav);
    }
  };

  PNHeaderV2.prototype.bind = function() {
    var $userMenu, $userName;
    if (($userName = $('.user-name')).length) {
      $userMenu = $('#ls-my-stuff');
      if (Groupon.LS.hasTouch) {
        return $userName.off('tap').on('tap', function(e) {
          e.preventDefault();
          e.stopImmediatePropagation();
          $userMenu.toggle();
          $userMenu.attr('aria-hidden', $userMenu.attr('aria-hidden') !== 'true');
          $('html').trigger('tap');
          if ($userMenu.is(':visible')) {
            return $('html').off('tap').one('tap', function(e) {
              if ($(e.target).closest('.user-name, .my-stuff').length === 0) {
                return $userMenu.hide().attr('aria-hidden', 'true');
              }
            });
          }
        });
      } else {
        return this.initMenuNavigation($userName, $userMenu, $userMenu.find('a'));
      }
    }
  };

  return PNHeaderV2;

})(Groupon.AriaMenuNavigation);

//# sourceMappingURL=data:application/json;base64,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
